var PNHeaderV2,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

require('../../../../../modules/gig_body/header/frontend/views/pn_primarynav');

module.exports = PNHeaderV2 = (function(superClass) {
  extend(PNHeaderV2, superClass);

  function PNHeaderV2($el) {
    this.$el = $el;
    this.$primaryNav = this.$el.find('.primary-nav');
    this.initialize();
  }

  PNHeaderV2.prototype.initialize = function() {
    if (!$('#ls-lite-header').length) {
      return new Groupon.LS.Header.PNPrimaryNav(this.$primaryNav);
    }
  };

  PNHeaderV2.prototype.bind = function() {
    var $userMenu, $userName;
    if (($userName = $('.user-name')).length) {
      $userMenu = $('#ls-my-stuff');
      if (Groupon.LS.hasTouch) {
        return $userName.off('tap').on('tap', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          $userMenu.toggle();
          $userMenu.attr('aria-hidden', $userMenu.attr('aria-hidden') !== 'true');
          $('html').trigger('tap');
          if ($userMenu.is(':visible')) {
            return $('html').off('tap').one('tap', function(e) {
              if ($(e.target).closest('.user-name, .my-stuff').length === 0) {
                return $userMenu.hide().attr('aria-hidden', 'true');
              }
            });
          }
        });
      } else {
        return this.initMenuNavigation($userName, $userMenu, $userMenu.find('a'));
      }
    }
  };

  return PNHeaderV2;

})(Groupon.AriaMenuNavigation);

//# sourceMappingURL=data:application/json;base64,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
